package devxertech.com.pages.blogs.blogPages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/blog-Page")
@Composable
fun BlogPage() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            image =   Res.Image.blog_header_2,
            breakpoint = breakpoint,
            headingText = "How AI Is Transforming Businesses in 2025 ",
            descriptionText = "By: Zahid Ramzan | Category: AI | Date: May 26, 2025",
            startProject = false,
        )
        BlogAboutSection()
        WhyAiImportantSection()
        BlogBusiness()
        BusinessUsageWithAI()
        ConclusionSection ()
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}